import React, { Component } from "react";
import { connect } from "react-redux";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";

import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import "../reports.css";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

class SafetySectionInspection extends Component {
    constructor(props) {
        super(props);
        let edit = props.location.pathname.split("/");

        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing: edit[1] === "report-view" ? false : true,
            title: document.title,
            reportType: edit[4].replace(/-/g, "_"),
        };

        props.getReport(
            props.match.params.uid,
            props.match.params.subject_name.replace(/-/g, "_"),
            props.match.params.report_id.replace(/_/g, " ").replace(/\./g, ":"),
            edit[4].replace(/-/g, "_")
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    style={{ width: "100%" }}
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    style={{ width: "100%" }}
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };

    render() {
        //let report = this.props.report === false ? false : this.props.report;
        let rT = this.renderText;
        let dp = this.renderDropDown;
        let gstyle = gridStyle;
        let cstyle = cellStyle;

        const { editing, reportType, report, selectedImg } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Block Vehicle Check Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader>
                    <Typography variant="h5">
                        Safety Section Inspection Report
                    </Typography>
                </StyledHeader>
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                            document.title =
                                "Safety Section Inspection - " +
                                this.props.match.params.report_id
                                    .replace(/_/g, " ")
                                    .replace(/\./g, ":");
                        }}
                        onAfterPrint={() => {
                            document.title = this.state.title;
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px",
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Safety Section Inspection Report
                                    </Typography>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>General Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Directorate/Function:</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {rT(
                                                "directorate_function",
                                                report.directorate_function
                                            )}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13)}>
                                            <b>Department/Section</b>
                                        </div>
                                        <div style={cstyle(2, 10, 2, 13, true)}>
                                            {rT(
                                                "department_section",
                                                report.department_section
                                            )}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Location:</b>
                                        </div>
                                        <div style={cstyle(3, 4, 3, 7, true)}>
                                            {rT("location", report.location)}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13)}>
                                            <b>Electoral Area:</b>
                                        </div>
                                        <div style={cstyle(3, 10, 3, 13, true)}>
                                            {rT(
                                                "electoral_area",
                                                report.electoral_area
                                            )}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Region:</b>
                                        </div>
                                        <div style={cstyle(4, 4, 4, 7, true)}>
                                            {dp("region", report.region, [
                                                "N/E",
                                                "S/W",
                                            ])}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13)}>
                                            <b>Zone:</b>
                                        </div>
                                        <div style={cstyle(4, 10, 4, 13, true)}>
                                            {dp("zone", report.zone, [
                                                "1",
                                                "2",
                                                "3",
                                                "4",
                                            ])}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Inspection Date:</b>
                                        </div>
                                        <div style={cstyle(5, 4, 5, 7, true)}>
                                            {rT(
                                                "inspection_date",
                                                report.inspection_date
                                            )}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13)}>
                                            <b>Inspection Time:</b>
                                        </div>
                                        <div style={cstyle(5, 10, 5, 13, true)}>
                                            {rT(
                                                "inspection_time",
                                                report.inspection_time
                                            )}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Inspection By:</b>
                                        </div>
                                        <div style={cstyle(6, 4, 6, 7, true)}>
                                            {rT(
                                                "inspection_by",
                                                report.inspection_by
                                            )}
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13)}>
                                            <b>Line Manager:</b>
                                        </div>
                                        <div style={cstyle(6, 10, 6, 13, true)}>
                                            {rT(
                                                "line_manager",
                                                report.line_manager
                                            )}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 13)}>
                                            <b>Work Activity:</b>
                                        </div>
                                        <div style={cstyle(7, 4, 7, 13, true)}>
                                            {rT(
                                                "work_activity",
                                                report.work_activity
                                            )}
                                        </div>
                                        <div style={cstyle(8, 1, 8, 7)}>
                                            <b>Please Confirm:</b>
                                        </div>
                                        <div style={cstyle(8, 4, 8, 7, true)}>
                                            {dp(
                                                "confirm_work_type",
                                                report.confirm_work_type,
                                                [
                                                    "Direct Labour",
                                                    "Direct Labour & Contractor",
                                                    "Contractor",
                                                ]
                                            )}
                                        </div>
                                        <div style={cstyle(8, 7, 8, 13)}>
                                            <b>Contractor Name:</b>
                                        </div>
                                        <div style={cstyle(8, 10, 8, 13, true)}>
                                            {rT(
                                                "contractor_name",
                                                report.contractor_name
                                            )}
                                        </div>
                                        <div style={cstyle(9, 1, 9, 13)}>
                                            <b>Purpose of Inspection:</b>
                                        </div>
                                        <div style={cstyle(9, 4, 9, 13, true)}>
                                            {rT(
                                                "inspection_purpose",
                                                report.inspection_purpose
                                            )}
                                        </div>

                                        <div style={cstyle(10, 1, 10, 13)}>
                                            <b>
                                                Due to serious and imminent
                                                danger, was work stopped?
                                            </b>
                                        </div>
                                        <div
                                            style={cstyle(10, 4, 10, 13, true)}
                                        >
                                            {dp(
                                                "work_stopped_due_to_danger",
                                                report.work_stopped_due_to_danger,
                                                ["Yes", "No"]
                                            )}
                                        </div>
                                        <div style={cstyle(11, 1, 11, 7)}>
                                            <b>Created By:</b>
                                        </div>
                                        <div style={cstyle(11, 4, 11, 7, true)}>
                                            {report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(11, 7, 11, 13)}>
                                            <b>Timestamp:</b>
                                        </div>
                                        <div
                                            style={cstyle(11, 10, 11, 13, true)}
                                        >
                                            {report.timestamp}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Report Details</b>
                                        </div>

                                        <div style={cstyle(2, 1, 2, 13, true)}>
                                            {rT(
                                                "report_details",
                                                report.report_details
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>SSIR Photo's</b>
                                        </div>
                                        <div style={cstyle(2, 1, 4, 7)}>
                                            <img
                                                src={
                                                    report.ssir_photo_1_url ===
                                                        undefined ||
                                                    report.ssir_photo_1_url ===
                                                        null ||
                                                    report.ssir_photo_1_url ===
                                                        ""
                                                        ? noImg
                                                        : report.ssir_photo_1_url
                                                }
                                                alt="Signature"
                                                style={{
                                                    width: "inherit",
                                                    height: "200px",
                                                }}
                                            />
                                        </div>

                                        <div style={cstyle(2, 7, 4, 13, true)}>
                                            <img
                                                src={
                                                    report.ssir_photo_2_url ===
                                                        undefined ||
                                                    report.ssir_photo_2_url ===
                                                        null ||
                                                    report.ssir_photo_2_url ===
                                                        ""
                                                        ? noImg
                                                        : report.ssir_photo_2_url
                                                }
                                                alt="Signature"
                                                style={{
                                                    width: "inherit",
                                                    height: "200px",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={gstyle(10, 13)}
                                        ref={(ref) => (this.infoDiv = ref)}
                                    >
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Signature</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Carried out by(print):</b>
                                        </div>
                                        <div style={cstyle(2, 4, 2, 7, true)}>
                                            {report.recorder_print_name
                                                ? report.recorder_print_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)} />

                                        <div style={cstyle(2, 7, 4, 13, true)}>
                                            <img
                                                src={
                                                    report.recorder_sig_url ===
                                                        undefined ||
                                                    report.recorder_sig_url ===
                                                        null ||
                                                    report.recorder_sig_url ===
                                                        ""
                                                        ? noImg
                                                        : report.recorder_sig_url
                                                }
                                                alt="Signature"
                                                style={{
                                                    width: "inherit",
                                                    height: "200px",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-edit",
                                "report-view"
                            )}
                        >
                            <div>
                                <Button
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        this.props.setReport(
                                            this.state.report,
                                            this.props.location.pathname,
                                            reportType
                                        );
                                        this.props.setActivity(
                                            "update",
                                            "report",
                                            this.state.reportType
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                                <Button color="primary" variant="contained">
                                    Cancel
                                </Button>
                            </div>
                        </Link>
                    )}
                    {!this.state.editing && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button variant="contained">Edit</Button>
                        </Link>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, setActivity }
)(SafetySectionInspection);
